import { IServiceFactory } from '../../common/types/service-factory';
import { ActivityApiService, IActivityApiService } from '../services/activity-api-service';
import { ApiServiceFactoryBase } from './base/api-service-factory-base';

export class ActivityApiServiceFactory extends ApiServiceFactoryBase implements IServiceFactory<IActivityApiService> {
	public Create(): IActivityApiService {
		return new ActivityApiService(this.apiServiceFactory.Create(), this.appConfigService);
	}
}
